import React from 'react';
import { ButtonColour } from 'components/Button/constants';
import { CardType } from 'components/Card/constants';
import { EventsActions, EventsCategories } from 'modules/gtm/constants';
import { getDateFormatted, getLink, truncate } from 'modules/utils/utils';
import { ThreeColResourceType } from './types';
import { TriggerGTMEvent } from 'modules/gtm';
import { useMediaQuery } from 'react-responsive';
import CtaButton from 'components/Cta/Button';
import * as Hyperlink from 'components/Hyperlink';
import Excerpt from '../components/Excerpt';
import Heading from '../components/Heading';
import Item from '../Item';
import Social from '../components/Social';
import TextLink from '../components/TextLink';
import styles from './styles.module.scss';
import { SocialMediaCard } from 'components/CMSModals/socialMediaCard';
export type ThreeColumnProps = {
  data: any[];
  displayDate?: boolean;
  handleBookmarkClick?: (contentTypeUid: string) => void;
};
const ThreeColumn: React.FunctionComponent<ThreeColumnProps> = ({
  data,
  displayDate = false,
  handleBookmarkClick,
}) => {
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });
  // console.log('datadatadatadata', data[0].navLink);
  const handleReadNow = (data: SocialMediaCard) => {
    localStorage.setItem('contentRowKey', data.contentRowKey);
    TriggerGTMEvent({
      action: EventsActions.CLICK_READ_NOW,
      category: EventsCategories.CONTENT,
      label: data.navLink,
    });
  };

  return (
    <div>
      {Array.from({ length: Math.ceil(data.length / 3) }, (_, rowIndex) => {
        const startIndex = rowIndex * 3;
        const rowItems = data.slice(startIndex, startIndex + 3);

        return (
          <div className={styles.ThreeColumnCards} key={`row-${rowIndex}`}>
            {rowItems.map((post: any, index: number) => {
              const actualIndex = startIndex + index;
              const itemDetailLink = post.navLink.split('/').slice(1).join('/');
              const textLinkCType = 'events';

              return (
                <Item
                  key={`event-${actualIndex}`}
                  image={post.imageUrl}
                  contentFull
                  imageSize={CardType.IMAGE_Med}
                  itemDetailLink={itemDetailLink}
                >
                  {displayDate && (
                    <time
                      className={styles.publicationDate}
                      dateTime={post.publicationDate}
                    >
                      {getDateFormatted(post.publicationDate)}
                    </time>
                  )}

                  <Hyperlink.CustomLink href={itemDetailLink}>
                    <Heading heading={truncate(post.title, 60)} />
                  </Hyperlink.CustomLink>

                  {!isMobile && (
                    <div className={styles.socialContainer}>
                      <Social
                        likes={post.likeCount}
                        liked={post.isLiked}
                        bookmarked={post.isSaved}
                        contentTypeUid={post.contentTitle}
                        handleBookmarkClick={handleBookmarkClick}
                        pageSlug={post.navLink}
                      />
                    </div>
                  )}

                  <div className={styles.introTextContainer}>
                    <Hyperlink.CustomLink href={itemDetailLink}>
                      <Excerpt excerpt={post.description} safe />
                    </Hyperlink.CustomLink>
                  </div>

                  <div className={styles.cardCta}>
                    {isMobile && (
                      <div className={styles.socialContainer}>
                        <Social
                          likes={post.likeCount}
                          liked={post.isLiked}
                          bookmarked={post.isSaved}
                          contentTypeUid={post.title}
                          handleBookmarkClick={handleBookmarkClick}
                          pageSlug={post.navLink}
                        />
                      </div>
                    )}

                    {isMobile ? (
                      <TextLink
                        content_type={textLinkCType}
                        label="Read now"
                        onClick={() => handleReadNow(post.navLink)}
                        slug={post.navLink}
                      />
                    ) : (
                      <CtaButton
                        defaultColour={ButtonColour.BRAND_BERRY}
                        label="Read now"
                        onClick={() => {
                          handleReadNow(post);
                        }}
                        page_link={itemDetailLink}
                        small
                      />
                    )}
                  </div>
                </Item>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ThreeColumn;
